var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-cascader",
    _vm._g(
      _vm._b(
        {
          directives: [{ name: "no-space", rawName: "v-no-space" }],
          attrs: {
            filterable: "",
            clearable: "",
            placeholder: _vm.placeholder,
            props: _vm.config,
            options: _vm.options,
          },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$slots, function (slot, slotName) {
                return {
                  key: slotName,
                  fn: function () {
                    return [_vm._t(slotName)]
                  },
                  proxy: true,
                }
              }),
            ],
            null,
            true
          ),
          model: {
            value: _vm.innerValue,
            callback: function ($$v) {
              _vm.innerValue = $$v
            },
            expression: "innerValue",
          },
        },
        "el-cascader",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }